import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'service-icons',
    templateUrl: './service-icons.component.html'
})
export class ServiceIconsComponent implements OnInit {
    @Input() businessTransactionId: number;
    @Input() disableRemove: boolean;
    @Input() disableUnassign: boolean;
    @Input() showServiceIcons: boolean;
    @Output() onHold = new EventEmitter<number>();
    @Output() onRemove = new EventEmitter<number>();
    @Output() onUnassign = new EventEmitter<number>();

    constructor() { }

    ngOnInit() {
    }

    holdTransaction(transactionId: number) {
        this.onHold.emit(transactionId);
    }

    removeTransaction(transactionId: number) {
        this.onRemove.emit(transactionId);
    }

    unassignTransaction(transactionId: number) {
        this.onUnassign.emit(transactionId);
    }
}
